import type { VueId } from "@/lib/types";

/** Chemin URL public pour chaque vue (rechargement = même page). */
export const VUE_PATHS: Record<VueId, string> = {
  accueil: "/",
  stock: "/stock",
  reception: "/receptions",
  ventes: "/ventes",
  fournisseurs: "/factures",
  fournisseursConfig: "/fournisseurs",
  inventaire: "/inventaire",
  associations: "/associations",
  fusions: "/fusions",
  achatsProduits: "/achats-produits",
};

const PATH_TO_VUE = new Map<string, VueId>(
  Object.entries(VUE_PATHS).map(([id, path]) => [path, id as VueId]),
);

export function pathForVue(vue: VueId): string {
  return VUE_PATHS[vue] ?? "/";
}

export function vueFromPath(pathname: string | null | undefined): VueId {
  if (!pathname) return "accueil";
  const clean = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  return PATH_TO_VUE.get(clean) ?? "accueil";
}
